import { APPLICANT_STAGE } from '../../RentalPortalApplicant'

export const APPLICANT_COLUMN_NAME = {
  ApprovalStatus: 'approval_status',
  ApprovedAt: 'approved_at',
  Building: 'building',
  Created: 'created',
  CreditCheckStatus: 'credit_check_status',
  DocumentCount: 'document_count',
  Flat: 'flat',
  IncomeProofStatus: 'income_proof_status',
  Listing: 'listing',
  MoveInDate: 'move_in_date',
  ReceivedAt: 'received_at',
  Reference: 'reference',
  ScreeningState: 'screening_state',
  SelectedAt: 'selected_at',
  Source: 'source',
  Stage: 'stage',
  Updated: 'updated',
}

export const APPLICANTS_CLEAR_FILTERS_ACTION_NAME = 'clearFilters'

export const APPLICANTS_RETRY_ACTION_NAME = 'retry'

// TODO: drop this list once the backend sends the flag in `available_filters`.
export const APPLICANTS_INITIAL_RANGE_FILTER_NAMES = [
  'received_at',
  'selected_at',
  'approved_at',
]

export const APPLICANTS_TABLE_SKELETON_ROWS = 10

export const QA_NAME_APPLICANTS_CLEAR_FILTERS = 'applicantsClearFilters'

export const QA_NAME_APPLICANTS_PAGE = 'rentalPortalApplicants'

export const QA_NAME_APPLICANTS_REFRESH_ERROR = 'applicantsRefreshError'

export const QA_NAME_APPLICANTS_RETRY = 'applicantsRetry'

export const APPLICANT_BOARD_COLUMN_ORDER = [
  APPLICANT_STAGE.pool,
  APPLICANT_STAGE.screening,
  APPLICANT_STAGE.selected,
  APPLICANT_STAGE.approved,
]

export const APPLICANT_BOARD_COLUMN_CAP = 25

export const APPLICANT_BOARD_SKELETON_CARDS = ['first', 'second']

export const QA_NAME_APPLICANT_BOARD = 'applicantBoard'

export const QA_NAME_APPLICANT_BOARD_CARD = 'applicantBoardCard'

export const QA_NAME_APPLICANT_BOARD_MORE = 'applicantBoardMore'

export const QA_NAME_APPLICANT_BOARD_SKELETON_CARD =
  'applicantBoardSkeletonCard'
